import { z } from "zod";

export const boundingBoxSchema = z.object({
  id: z.string(),
  bbox: z.object({
    xywh: z.array(z.number()),
  }),
  page: z.number(),
  content: z.string(),
});

export const extractionMetadataSchema = z.object({
  bboxes: z.array(boundingBoxSchema),
  confidence: z.string(),
  annotation_ids: z.array(z.string()),
});

export type BoundingBox = z.infer<typeof boundingBoxSchema>;
export type ExtractionMetadata = z.infer<typeof extractionMetadataSchema>;
